import React, { useState, useRef } from 'react';
import DefaultLayout from 'app/layouts/DefaultLayout';
import MainContentLayout from 'app/layouts/MainContentLayout';
import HeroSection from './components/HeroSection';
import QuestionSection from './components/QuestionSection';
import AnalysisResultSection from './components/AnalysisResultSection';
import PremiumServiceSection from './components/PremiumServiceSection';
import ServiceDetailsSection from './components/ServiceDetailsSection';
import { analyzeScalpCondition } from '../../services/api';
import { toast } from 'react-toastify';

function ScalpAnalysis() {
  const [answers, setAnswers] = useState({
    q1: '',
    q2: '',
    q3: [],
    q4: [],
    q5: '',
    q6: '',
    q7: [],
  });

  const [analysisResult, setAnalysisResult] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const questionRef = useRef(null);
  const analysisRef = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleStartDiagnosis = () => {
    scrollToSection(questionRef);
  };

  const handleAnswerChange = (questionId, value) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };

  const isFormValid = () => {
    return (
      answers.q1 !== '' &&
      answers.q2 !== '' &&
      answers.q3.length > 0 &&
      answers.q4.length > 0 &&
      answers.q5 !== '' &&
      answers.q6 !== '' &&
      answers.q7.length > 0
    );
  };

  const handleSubmitAnalysis = async () => {
    if (!isFormValid()) return;

    setIsAnalyzing(true);
    setAnalysisResult(null);
    try {
      const result = await analyzeScalpCondition(answers);
      console.log('result', result);
      if (result.success) {
        setAnalysisResult(result.data);
        setTimeout(() => {
          scrollToSection(analysisRef);
        }, 300);
      } else {
        console.error('Analysis error:', result.message);
        toast.error('解析に失敗しました');
      }
    } catch (error) {
      console.error('Analysis error:', error);
      toast.error('解析に失敗しました');
    } finally {
      setIsAnalyzing(false);
    }
  };

  const handleUpdateAnswers = () => {
    scrollToSection(questionRef);
  };

  return (
    <DefaultLayout>
      <MainContentLayout contentClass="h-full">
        <div className="w-full h-full overflow-auto bg-white">
          <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-100">
            <div className="flex items-center px-4 h-14 justify-center max-w-md mx-auto w-full">
              <div className="flex items-center gap-2">
                <span className="material-symbols-outlined text-blue-btn-primary">psychology_alt</span>
                <h2 className="text-slate-900 text-base font-bold tracking-tight">頭皮判定サービス</h2>
              </div>
            </div>
          </header>

          <main className="relative flex flex-col w-full">
            <HeroSection onStartDiagnosis={handleStartDiagnosis} />

            <div ref={questionRef}>
              <QuestionSection
                answers={answers}
                onAnswerChange={handleAnswerChange}
                onSubmit={handleSubmitAnalysis}
                isValid={isFormValid()}
                isAnalyzing={isAnalyzing}
              />
            </div>

            {analysisResult && (
              <>
                <div ref={analysisRef}>
                  <AnalysisResultSection
                    result={analysisResult}
                    onUpdateAnswers={handleUpdateAnswers}
                  />
                </div>
                <PremiumServiceSection />
                <ServiceDetailsSection />
              </>
            )}
          </main>
        </div>
      </MainContentLayout>
    </DefaultLayout>
  );
}

export default ScalpAnalysis;
